class Accordion {
	static uid = 1;

	constructor(root, options = {}) {
		this.root   = root; // ← .product_detail（＝is-openを付ける場所）
		this.target = root.querySelector('[data-accordion]'); // 使うならスタイル用に
		this.btn    = root.querySelector('[data-toggle-accordion]');
		this.panel  = root.querySelector('.accordion_inner');
	
		if (!this.btn || !this.panel) {
			console.warn('Accordion: missing button or panel', root);
			return;
		}
	
		this.options = {
			duration:  options.duration ?? 300,
			exclusive: options.exclusive ?? false, // 同じ親内で単一オープン
			rootOpenClass: options.rootOpenClass ?? 'is-open',
			// 同階層で排他にする対象（親要素直下の子を想定）
			siblingItemSelector: options.siblingItemSelector ?? '.product_detail'
		};
	
		// ARIA
		if (!this.btn.id)   this.btn.id   = `acc_btn_${Accordion.uid++}`;
		if (!this.panel.id) this.panel.id = `acc_${Accordion.uid++}`;
		this.btn.setAttribute('aria-controls', this.panel.id);
		this.btn.setAttribute('aria-expanded', 'false');
		this.panel.setAttribute('role', 'region');
		this.panel.setAttribute('aria-labelledby', this.btn.id);
	
		// 初期スタイル
		this.panel.hidden = true;
		this.panel.style.height = '0px';
		this.panel.style.overflow = 'hidden';
		
		
		// 事前に .is-open が付いていたら開いた状態で開始
		if (this.root.classList.contains(this.options.rootOpenClass)) {
			this.btn.setAttribute('aria-expanded', 'true');
			this.panel.hidden = false;
			this.panel.style.height = 'auto';
		}
	
		// バインド
		this.onClick = this.onClick.bind(this);
		this.btn.addEventListener('click', this.onClick);
	}

	isOpen() {
		return this.btn.getAttribute('aria-expanded') === 'true';
	}

	open() {
		if (this.isOpen()) return;
		
		// 排他処理：兄弟の .product_detail を閉じる
		if (this.options.exclusive && this.root.parentElement) {
			this.root.parentElement
			.querySelectorAll(this.options.siblingItemSelector)
			.forEach((sib) => {
				if (sib !== this.root && sib.__accordion?.isOpen()) {
					sib.__accordion.close();
				}
			});
		}
		
		this.panel.hidden = false;
		this.btn.setAttribute('aria-expanded', 'true');
		this.root.classList.add(this.options.rootOpenClass);
		
		let accordionInner = this.panel.querySelector(".accordion_content");
		let contentH 	= accordionInner.clientHeight - 100;
		let headH 		= document.querySelector(".product.cols").offsetTop + document.querySelector("#global_header").clientHeight;
		let accordionH 	= window.innerHeight - headH;
		let diff 		= contentH - accordionH;
		let stickyTop = diff - headH;
		//console.log(diff, headH, stickyTop);
		//let stickyTop = accordionY - contentH;
		document.documentElement.style.setProperty("--product-sticky-top", `${-stickyTop}px`);
		
		const target = this.panel.scrollHeight;
		this._animateHeight(target, () => {
			this.panel.style.height = 'auto'; // 開いた後はautoでレイアウト追従
		});
		if( window.innerWidth < 960 ){
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			})
		}
	}

	close() {
		if (!this.isOpen()) return;
		
		// auto → 数値へ戻す（スムーズに閉じるため）
		this.panel.style.height = `${this.panel.scrollHeight}px`;
		this.panel.offsetHeight; // reflow
		
		this.btn.setAttribute('aria-expanded', 'false');
		
		this._animateHeight(0, () => {
			this.panel.hidden = true;
			this.panel.style.height = '0px';
			this.root.classList.remove(this.options.rootOpenClass);
		});
	}

	toggle() {
		this.isOpen() ? this.close() : this.open();
	}

	onClick(e) {
		e.preventDefault();
		this.toggle();
	}

	_animateHeight(target, done) {
		const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		const dur = reduce ? 0 : this.options.duration;
		
		if (dur === 0) {
			this.panel.style.height = `${target}px`;
			done?.();
			return;
		}
		
		this.panel.style.transition = `height ${dur}ms ease`;
		const onEnd = (ev) => {
			if (ev.propertyName !== 'height') return;
			this.panel.style.transition = '';
			this.panel.removeEventListener('transitionend', onEnd);
			done?.();
		};
		this.panel.addEventListener('transitionend', onEnd);
		
		requestAnimationFrame(() => {
			this.panel.style.height = `${target}px`;
		});
	}

	destroy() {
		this.btn.removeEventListener('click', this.onClick);
	}
}

export let accordions = {
	list: [],
	init(options = {}) {
		accordions.list = [];
		const parents = document.querySelectorAll('.product_detail');
		this.list = Array.from(parents).map((el) => {
			const inst = new Accordion(el, options);
			el.__accordion = inst;       // 排他処理で使うのでセットしておく
			return inst;
		});
		//console.log("accordion", this.list);
		accordions.resize();
	},
	resize: function(){
		let isPC = window.innerWidth >= 960;
		if( isPC ){
			let $accordions = document.querySelectorAll(".product_detail");
			$accordions.forEach( ($a, index) => {
				let panel = $a.querySelector("[data-accordion] .accordion_inner");
				$a.querySelector("[data-toggle-accordion]").setAttribute('aria-expanded', 'true');
				panel.hidden 		= false;
				panel.style.height 	= 'auto';
				$a.classList.add('is-open');
			});
		}else{
			
		}
	},
	open: function(i)   { this.list[i]?.open(); },
	close: function(i)  { this.list[i]?.close(); },
	toggle: function(i) { this.list[i]?.toggle(); },
};